"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleText = void 0;
var react_1 = __importDefault(require("react"));
var title_text_module_scss_1 = __importDefault(require("./title-text.module.scss"));
var classnames_1 = __importDefault(require("classnames"));
var defaultProps = {
    as: 'p',
    color: 'primary',
    size: 'large'
};
// 👀 exporting as a const in addition to default to fix issue where Storybook loses descriptions and defaults
// eslint-disable-next-line import/export, no-redeclare
var TitleText = function (_a) {
    var _b, _c;
    var _d = _a.as, Component = _d === void 0 ? defaultProps.as : _d, children = _a.children, className = _a.className, _e = _a.color, color = _e === void 0 ? defaultProps.color : _e, _f = _a.size, size = _f === void 0 ? defaultProps.size : _f, intrinsicElementProps = __rest(_a, ["as", "children", "className", "color", "size"]);
    // mortar-core typography sizes are not defined relative to Body/Title/Label/Utility, so their respective sizes have to be mapped to mortar-core sizes
    var sizeMap = {
        xxlarge: 'xxxxlarge',
        xlarge: 'xxxlarge',
        large: 'xxlarge',
        medium: 'xlarge',
        small: 'large'
    };
    var sizeClasses;
    if (typeof size === 'string') {
        sizeClasses = "pg--size-".concat(sizeMap[size]);
    }
    else {
        var sizeMd = (_b = size.medium) !== null && _b !== void 0 ? _b : size.small;
        var sizeLg = (_c = size.large) !== null && _c !== void 0 ? _c : sizeMd;
        var smallSize = title_text_module_scss_1.default["".concat(size.small, "-on-sm-screen")];
        var mediumSize = title_text_module_scss_1.default["".concat(sizeMd, "-on-md-screen")];
        var largeSize = title_text_module_scss_1.default["".concat(sizeLg, "-on-lg-screen")];
        sizeClasses = "".concat(smallSize, " ").concat(mediumSize, " ").concat(largeSize);
    }
    var cls = (0, classnames_1.default)("pg--fontFamily-sansSerif", sizeClasses, "pg--variant-".concat(color), className);
    return (react_1.default.createElement(Component, __assign({ className: cls }, intrinsicElementProps), children));
};
exports.TitleText = TitleText;
exports.TitleText.defaultProps = defaultProps;
